import * as React from 'react';
import ReactDOM from 'react-dom/client';

import ProductRecommend from './recommend.component';

// Function to check if the DOM element "product-recommend" exists
const checkElementExistence = (element: string) => {
    const foundElement = document.getElementById(element);

    // If the element exists, add event listener
    if (foundElement) {
        const root = ReactDOM.createRoot(foundElement);
        root.render(
            <React.StrictMode>
                <ProductRecommend detail={null} />
            </React.StrictMode>,
        );
        foundElement.classList.add('listenerAdded');
    } else {
        setTimeout(checkElementExistence, 300);
    }
};

checkElementExistence('product-recommend');
